import axios from "axios";

// Dynamically set the base URL based on the environment
const baseUrl = process.env.NODE_ENV === 'production' 
  ? '/PHP/'  
  : 'http://localhost:8000/'; 

// export const api = axios.create({
//   baseURL: baseUrl,
// });
export const api = axios.create({
  baseURL: baseUrl,
  timeout: 30000, // 30 seconds timeout
});

// Add request interceptor to set Content-Type for JSON requests
api.interceptors.request.use(
  (config) => {
    // Only set Content-Type for JSON requests (not FormData)
    if (config.data && !(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
